var map = {
	"./vol1/IMG_20171123_175247.jpg": 157
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88;



//////////////////
// WEBPACK FOOTER
// ./images ^\.\/vol.*$
// module id = 88
// module chunks = 106735565224735 162114328119038